export function InsertLinkShortcut(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      fill="none"
      {...props}
    >
      <path
        d="M7.038 16.538a4.374 4.374 0 0 1-3.211-1.327A4.373 4.373 0 0 1 2.5 12a4.375 4.375 0 0 1 1.328-3.211 4.373 4.373 0 0 1 3.21-1.327h3.019a.75.75 0 1 1 0 1.5H7.037A3.037 3.037 0 0 0 4 12a3.037 3.037 0 0 0 3.037 3.038h3.02a.75.75 0 1 1 0 1.5ZM9 12.75a.75.75 0 1 1 0-1.5h6a.75.75 0 1 1 0 1.5Zm4.942 3.789a.75.75 0 1 1 0-1.5h3.02A3.037 3.037 0 0 0 20 12a3.037 3.037 0 0 0-3.037-3.038h-3.02a.75.75 0 1 1 0-1.5h3.019A4.532 4.532 0 0 1 21.5 12a4.533 4.533 0 0 1-4.538 4.539Z"
        fill="currentColor"
      />
    </svg>
  );
}
